<style lang="scss" scoped>
    header {
        display: flex;
        justify-content: space-between;
        padding: 25px;
        text-transform: uppercase;
        font-weight: bold;
        z-index: z(header);

        @include above(md) {
            padding: 50px 75px;
        }

        a {
            @include link-colors($white, $white);
        }

        .logo {
            font-family: serif;
            font-size: toRem(20px);
            line-height: lh(25px, 20px);
            letter-spacing: 7.2px;

            img {
                width: 150px;
                height: auto;
                display: block;
                @include above(md) {
                    width: 250px;
                }
            }

            @include above(md) {
                font-size: toRem(32px);
                line-height: lh(37px, 32px);
            }
        }

        nav {
            font-size: toRem(15px);
            line-height: lh(21px, 15px);
            letter-spacing: 5px;

            @include above(md) {
                letter-spacing: 10.4px;
                font-size: toRem(17px);
                line-height: lh(23px, 17px);
            }

            .close {
                display: flex;
                align-items: center;
                &:after {
                    content: '';
                    width: 18px;
                    height: 20px;
                    margin-left: 4px;
                    background-image: url('/img/icons/close-white.svg');
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: contain;
                }
            }
        }
    }
</style>
<template>
    <header>
        <div class="logo">
            <router-link :to="{name: 'SpeciesView'}">
                <img src="/img/logo.png" alt="Genomic Cytometry - A multi-omics project">
            </router-link>
        </div>
        <nav>
            <a v-if="!close" href="#!" @click.prevent="$emit('about-click')">about</a>
            <a v-else href="#!" class="close" @click.prevent="$emit('close')">close</a>
        </nav>
    </header>
</template>
<script>
export default {
    name: 'AppHeader',
    props: {
        close: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
